<template lang="pug">
  .room.saddle-room
    SwitchStatus.divice-block-thin(title="鞍室除湿机组运行状态" :series="SwitchStatusData")
    RunningTime.divice-block-thin(title="鞍室除湿机组累计运行时间" :series="RunningTimeData")
    .divice-block(:class="warningFlag1")
      .divice-block-1
        DoubleGraph(:opts="humidity1" :series="humidity1Data")
      .divice-block-2
        SinglePieHistogramWrap(:opts="SinglePieHistogramWrapOpts1" :series="SinglePieHistogramWrapData1" )
    .divice-block(:class="warningFlag2")
      .divice-block-1
        DoubleGraph(:opts="humidity2" :series="humidity2Data")
      .divice-block-2
        SinglePieHistogramWrap(:opts="SinglePieHistogramWrapOpts2" :series="SinglePieHistogramWrapData2" )
    .divice-block(:class="warningFlag3")
      .divice-block-1
        DoubleGraph(:opts="humidity3" :series="humidity3Data")
      .divice-block-2
        SinglePieHistogramWrap(:opts="SinglePieHistogramWrapOpts3" :series="SinglePieHistogramWrapData3" )
    .divice-block(:class="warningFlag4")
      .divice-block-1
        DoubleGraph(:opts="humidity4" :series="humidity4Data")
      .divice-block-2
        SinglePieHistogramWrap(:opts="SinglePieHistogramWrapOpts4" :series="SinglePieHistogramWrapData4" )
    RefreshBlock(@refreshData="refreshData")
</template>
<script>
export default {
  name: 'saddleRoom',
  data () {
    return {
      timer: null,
      SwitchStatusData: null,
      RunningTimeData: null,
      warningFlag1: '',
      warningFlag2: '',
      warningFlag3: '',
      warningFlag4: '',
      humidity1: {
        title: '鞍室温湿度1',
        legend1: '湿度',
        legend2: '温度'
      },
      humidity1Data: null,
      humidity2: {
        title: '鞍室温湿度2',
        legend1: '湿度',
        legend2: '温度'
      },
      humidity2Data: null,
      humidity3: {
        title: '鞍室温湿度3',
        legend1: '湿度',
        legend2: '温度'
      },
      humidity3Data: null,
      humidity4: {
        title: '鞍室温湿度4',
        legend1: '湿度',
        legend2: '温度'
      },
      humidity4Data: null,
      SinglePieHistogramWrapData1: null,
      SinglePieHistogramWrapOpts1: {
        title: '当前温湿度',
        histogramName1: 'T',
        center1: ['50%', '60%'],
        radius1: ['46%', '70%'],
        pieName1: 'RH',
        max: 100,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      },
      SinglePieHistogramWrapData2: null,
      SinglePieHistogramWrapOpts2: {
        title: '当前温湿度',
        histogramName1: 'T',
        center1: ['50%', '60%'],
        radius1: ['46%', '70%'],
        pieName1: 'RH',
        max: 100,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      },
      SinglePieHistogramWrapData3: null,
      SinglePieHistogramWrapOpts3: {
        title: '当前温湿度',
        histogramName1: 'T',
        center1: ['50%', '60%'],
        radius1: ['46%', '70%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      },
      SinglePieHistogramWrapData4: null,
      SinglePieHistogramWrapOpts4: {
        title: '当前温湿度',
        histogramName1: 'T',
        center1: ['50%', '60%'],
        radius1: ['46%', '70%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      }
    }
  },
  mounted () {
    this.getDatas()
    this.getLineDatas()
    this.timer = setInterval(() => {
      this.getDatas()
      this.getLineDatas()
    }, this.REFRESH_SECOND)
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  methods: {
    refreshData () {
      this.getDatas()
      this.getLineDatas()
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.getDatas()
        this.getLineDatas()
      }, this.REFRESH_SECOND)
    },
    setPieHisData (datas, dataName, data1Id, data2Id, warnName) {
      this[dataName] = {
        data1: datas[data1Id].value,
        data2: datas[data2Id].value
      }
      if (datas[data2Id].errorLevel !== 'Normal' && this[warnName] !== 'Error') {
        this[warnName] = datas[data2Id].errorLevel
      }
      if (datas[data1Id].errorLevel !== 'Normal' && this[warnName] !== 'Error') {
        this[warnName] = datas[data1Id].errorLevel
      }
    },
    getDatas () {
      this.$http.get('/deviceData/Station?stationId=10f54b91-d423-49b7-bb65-2afd0237e3ac').then(res => {
        this.$store.commit('setLastRefreshTime')
        const __data = res.data
        this.setPieHisData(__data, 'SinglePieHistogramWrapData1', '878be086-48fe-4237-a160-638349e0b1c2', 'c98c14c8-eef4-4a3b-afe3-e2ae9cabc141', 'warningFlag1')
        this.setPieHisData(__data, 'SinglePieHistogramWrapData2', '423a2109-9ad8-408c-9675-4919b5b1398b', '1f6f646a-5bfe-4392-841c-ae45549cd889', 'warningFlag2')
        this.setPieHisData(__data, 'SinglePieHistogramWrapData3', '67d8e86d-a537-483a-b03f-79a12a07d473', '657bb351-dde8-4204-be6c-d49011077491', 'warningFlag3')
        this.setPieHisData(__data, 'SinglePieHistogramWrapData4', '75208f13-9c10-4e15-9700-4282f8e2c2e8', '0d478c65-65f0-4918-b614-df2d8be564c5', 'warningFlag4')
        this.SwitchStatusData = {
          data: __data['5807485f-4a53-4e22-8b85-d930ab90d4bf'].value,
          isError: __data['5807485f-4a53-4e22-8b85-d930ab90d4bf'].errorLevel
        }
        this.RunningTimeData = __data['b6a1f39c-36e4-42c1-9e20-3fcf64d5b492'].value
      })
    },
    GetDeviceData (id) {
      return this.$http.get('/statistics/DeviceData?deviceId=' + id + '&interval=BY_HOUR&insertBlankData=true')
    },
    getLineDatas () {
      const that = this
      this.$http.all([this.GetDeviceData('878be086-48fe-4237-a160-638349e0b1c2'), this.GetDeviceData('c98c14c8-eef4-4a3b-afe3-e2ae9cabc141')])
        .then(
          that.$http.spread(function (res1, res2) {
            that.dealData(res1, res2, 'humidity1Data', that, 'warningFlag1')
          })
        )
      this.$http.all([this.GetDeviceData('423a2109-9ad8-408c-9675-4919b5b1398b'), this.GetDeviceData('1f6f646a-5bfe-4392-841c-ae45549cd889')])
        .then(
          that.$http.spread(function (res1, res2) {
            that.dealData(res1, res2, 'humidity2Data', that, 'warningFlag2')
          })
        )
      this.$http.all([this.GetDeviceData('67d8e86d-a537-483a-b03f-79a12a07d473'), this.GetDeviceData('657bb351-dde8-4204-be6c-d49011077491')])
        .then(
          that.$http.spread(function (res1, res2) {
            that.dealData(res1, res2, 'humidity3Data', that, 'warningFlag3')
          })
        )
      this.$http.all([this.GetDeviceData('75208f13-9c10-4e15-9700-4282f8e2c2e8'), this.GetDeviceData('0d478c65-65f0-4918-b614-df2d8be564c5')])
        .then(
          that.$http.spread(function (res1, res2) {
            that.dealData(res1, res2, 'humidity4Data', that, 'warningFlag4')
          })
        )
    },
    dealData (res1, res2, name, that, warnName) {
      const __data = {}
      const __data1 = {}
      const _list1 = res1.data.dataList // .splice(-10)
      _list1.forEach((el, index) => {
        __data[el.dataDate] = el.value
      })
      const _list2 = res2.data.dataList // .splice(-10)
      _list2.forEach((el, index) => {
        __data1[el.dataDate] = el.value
      })
      that[name] = {
        data1: __data,
        data2: __data1
      }
      if (res1.data.errorLevel !== 'Normal' && that[warnName] !== 'Error') {
        that[warnName] = res1.data.errorLevel
      }
      if (res2.data.errorLevel !== 'Normal' && that[warnName] !== 'Error') {
        that[warnName] = res2.data.errorLevel
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.saddle-room {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  padding-top: 10px;
  .divice-block {
    width: calc(50% - 10px);
    height: calc(50% - 40px);
  }
  .divice-block-thin {
    height: 42px;
    width: calc(50% - 10px);
    box-sizing: border-box;
  }
  .divice-block {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    position: relative;
  }
  .divice-block-1 {
    width: 75%;
    height: 100%;
  }
  .divice-block-2 {
    width: 24%;
    height: 96%;
  }
}
</style>
